import { connect } from 'react-redux';
import Import from './import'
import * as AC from '../../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        isProcessing: state.upload.isProcessing,
        error: state.upload.error
}};

function mapDispatchToProps(dispatch) {
    return({
        importFile: (attachment) => { dispatch(AC.UploadFileStarted(attachment) ) },
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(Import);